<template lang="pug">
    v-container(grid-list-md v-if="content && request")
        v-layout(wrap)
            v-flex(lg8 md8 xs12)
                v-text-field(dense v-model="source" label="No. Rekening Sumber" readonly)
                    template(v-slot:prepend)
                        v-icon(color="warning") mdi-credit-card-multiple-outline
            v-flex(lg8 md8 xs12)
                v-text-field(dense v-model="content.summary.productDescription.toUpperCase()" label="Jenis Transaksi" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg8 md8 xs12)
                v-text-field(dense v-model="content.info.instanceName" label="Penyedia Jasa" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg8 md8 xs12)
                v-text-field(dense v-model="customerId" label="No. Virtual Account" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-account-check-outline
            v-flex(lg8 md8 xs12 v-if="content.note")
                v-text-field(dense v-model="content.note" label="Berita" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-note-text-outline
            v-flex(lg8 md8 xs12 v-if="content.customerRef")
                v-text-field(dense v-model="content.customerRef" label="No. Dokumen" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-file-document-outline
            v-flex(lg8 md8 xs12 v-if="request.data.billInfo.invoiceId")
                v-text-field(dense v-model="invoice" label="No. Invoice" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-account-check-outline
            v-flex(lg8 md8 xs12 v-if="request.data.billInfo.installmentId")
                v-text-field(dense v-model="installment" label="No. Installment" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-account-check-outline
            v-flex(lg7 md7 xs12)
                f-decimalbox(v-model="request.data.amount" label="Nominal" readonly :template="true")
</template>
<script>
export default {
    name: "FMultiPaymentDetailContent",
    props: ["content", "request", "transaction"],
    computed: { 
        source() {
            return this.$options.filters.accountformat(this.content.source) + " - " + this.content.sourceName;
        },
        customerId() {
            return this.content.parameters.virtualAccountNumber + " - " + this.content.info.customerName;
        },
        invoice() {
            return this.request.data.billInfo.invoiceId + " - " + this.request.data.billInfo.invoiceMessage;
        },
        installment() {
            return this.request.data.billInfo.installmentId + " - " + this.request.data.billInfo.installmentMessage;
        }
    },
};
</script>